import { XCircleIcon } from "@heroicons/react/24/outline";
import React from "react";
import { IdentityFragment } from "../../graphql/generated";
import { ZenDialog } from "../../common/components/zen-dialog";

export const DeleteIdentityLegacyDialog: React.FC<{
  identity?: IdentityFragment;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}> = ({ identity: bucket, isOpen, onClose, onSubmit }) => {
  if (!bucket) {
    return <></>;
  }

  return (
    <ZenDialog
      show={isOpen}
      title="Delete Legacy Identity"
      icon={XCircleIcon}
      submit="Delete"
      onSubmit={() => onSubmit()}
      onCancel={onClose}
    >
      <div className="mt-1">
        Are you sure you want to delete <strong>{bucket.name}</strong>?
      </div>
    </ZenDialog>
  );
};
